import { useEffect, useState } from 'react'

//Funciones comunes
import { LogErrors } from './../../../../../utilities/LogErrors'

//Componentes comunes
import { Loading } from './../../../../Common/Loading'

//Funciones personalizadas del proyecto
import { GetRandomizedQuestions, GetCorrectAnswers } from './../../../../../utilities/BL/Student/Instruments'
import { InstrumentData } from './../../../V2/Commons/InstrumentData'

//Agregar el multiidioma en mensajes y errores


const Quizzes = ({ instrument, instrumentData = null }) => {
    const [isLoading, setIsLoading] = useState(true)

    const [questions, setQuestions] = useState(instrument.quizz.questions)
    const [selectedAnswers, setSelectedAnswers] = useState({})
    const [showResults, setShowResults] = useState(false)
    const [correctAnswers, setCorrectAnswers] = useState(0)
    const [resultsSent, setResultsSent] = useState(false)


    const ValidateAnswers = async () => {
        try {
            if (!showResults) {
                const response = await GetCorrectAnswers(questions,selectedAnswers)

                if (response.success) {
                    setCorrectAnswers(response.data)
                    setShowResults(true)
                } else {
                    //Mostrar mensaje de que no se puedo obtener la info o el error
                    console.log("Hubo un error al evaluar tus respuestas") //Mensaje temporal
                }
            }
        } catch (error) {
            await LogErrors('ValidateAnswers - Quizzes', error)
        }
    }

    const Retry = async () => {
        try {
            setSelectedAnswers({})
            setShowResults(false)
            
            const response = await GetRandomizedQuestions(instrument.quizz.questions)

            if (response.success) {
                setQuestions(response.data)
            } else {
                //Mostrar mensaje de que no se puedo obtener la info o el error
                console.log("Hubo un error y no se pudo generar un reintento.") //Mensaje temporal
            }
        } catch (error) {
            await LogErrors('Retry - Quizzes', error)
        }
    }

    const handleOptionChange = async (questionIndex, optionText) => {
        try {
            if (!showResults) {
                setSelectedAnswers({
                    ...selectedAnswers,
                    [questionIndex]: optionText
                })
            }
        } catch (error) {
            await LogErrors('handleOptionChange - Quizzes', error)
        }
    }
    
    const LoadPage = async () => {
        try {
            const response = await GetRandomizedQuestions(instrument.quizz.questions)

            if (response.success) {
                setQuestions(response.data)
            } else {
                //Mostrar mensaje de que no se puedo obtener la info o el error
                console.log("Hubo un error y no se pudo generar un reintento.") //Mensaje temporal
            }
        } catch (error) {
            await LogErrors('LoadPage - Quizzes', error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])


    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <InstrumentData data={instrumentData} />

                <div className="container Quizzes Fonts--PlusJakartaSans">
                    {/* Renderizar las preguntas */}
                    {questions.map((question, index) => (
                        <div key={index} className={`Quiz-Question-Question ${!selectedAnswers[index] && showResults ? 'Quiz-Question-Question-Wrong' : ''}`}>
                            <p className="Quiz-Question-Text" dangerouslySetInnerHTML={{ __html: question.question }} />
                            
                            {question.options.map((option, optionIndex) => (
                                <label key={optionIndex} className='Quiz-Question-Option-Label'>
                                    <input type="radio" name={`Quiz-Question-${index}`} className="Quiz-Question-Option-Radio" value={option.text} checked={selectedAnswers[index] === option.text} onChange={() => handleOptionChange(index, option.text)} /> {option.text}
                                </label>
                            ))}

                            {/* Mostrar mensaje de resultado para cada pregunta */}
                            {showResults && (
                                selectedAnswers[index] === question.options.find(option => option.isCorrect)?.text ? (
                                    <p className={`Quiz-Question-Result-${selectedAnswers[index] === question.options.find(option => option.isCorrect)?.text ? 'Good' : 'Bad'}`} dangerouslySetInnerHTML={{ __html: question.messageGood }} />
                                ) : (
                                    <p className={`Quiz-Question-Result-${selectedAnswers[index] === question.options.find(option => option.isCorrect)?.text ? 'Good' : 'Bad'}`} dangerouslySetInnerHTML={{ __html: question.messageBad }} />
                                )
                            )}
                        </div>
                    ))}

                    {/* Mostrar resultados generales y botones */}
                    {showResults ? (
                        <>
                            <p className="Quiz-Question-CorrectAnswers">Respuestas correctas: {correctAnswers} de {questions.length} ({((correctAnswers / questions.length) * 100).toFixed(2)}%)</p>

                            <div className="Quiz-Question-Buttons">
                                <button type="button" className="Quiz-Question-Buttons-Retry" onClick={Retry}><i className="bi bi-arrow-counterclockwise"></i> Reintentar</button>
                            </div>
                        </>
                    ) : (
                        <div className="Quiz-Question-Buttons">
                            <button type="button" className="Quiz-Question-Buttons-Validate" onClick={ValidateAnswers} disabled={showResults}><i className="bi bi-check"></i> Validar</button>
                        </div>
                    )}
                </div>
            </>
        )
    )
}

export { Quizzes };